import { isEmpty } from "lodash";

export const validateUseCaseKey = (useCaseKey?: string | null): boolean => {
  return useCaseKey !== undefined && !isEmpty(useCaseKey);
};
